export default class QueriesController {
  _requestService;
  _paths;

  constructor(requestService, paths) {
    this._requestService = requestService;
    this._paths = paths;
  }

  async fetchTodayTasksRequest(childId) {
    const path = this._paths.todayTasksListPath(childId);
    const { data } = await this._requestService.Get(path);
    return data;
  }
}
